module.exports = {
    productRestrictions: {
        expressQuantityRestrictedByBundlesMessage: 'Bundles contain multiple individual items that count towards your overall limit for Express Delivery.',
        productTileRestrictionDeliveryOnly: 'Available for delivery orders only',
        productTileRestrictionExpressDeliveryOnly: 'Available for express delivery orders only',
        productTileRestrictionPickUpOnly: 'Available for pick up orders only',
        productTileRestrictionPmDelivery: 'Available for afternoon delivery and pick up orders',
        restrictedByExpressDeliveryMessage: 'These items are not available for Express Delivery, please select another delivery method',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/product-restrictions.js